import React, { FunctionComponent } from 'react';
import { FooterLinks } from 'scenes/common/components/Footer/FooterTop/FooterLinks';
import { FooterContainer } from 'scenes/common/components/FullPageWrapper';
import { Column, Row, Container } from '@iag-packages/chroma-react/lib/layouts';
import { FooterBottom } from 'scenes/common/components/Footer';

import {
  financialServiceGuide,
  keyFactSheet,
  privacyPolicyInfo,
  productDisclosureStatement,
  termsAndConditions,
} from 'scenes/common/helpers/contacts';

export const informationLinks = [
  financialServiceGuide,
  keyFactSheet,
  productDisclosureStatement,
  termsAndConditions,
  privacyPolicyInfo,
];

const Footer: FunctionComponent = () => (
  <FooterContainer>
    <Container>
      <Row>
        <Column xs={12} md={10} mdOffset={1}>
          <FooterLinks informationLinks={informationLinks} />
        </Column>
      </Row>
    </Container>
    <FooterBottom />
  </FooterContainer>
);

export default Footer;
